/**
 * Shared read-only rules for archived TrialStudy rows.
 * Used by Study Management, Study Profile, eISF, and Schedule.
 */
import { isStudyAlreadyArchived } from "./studyArchiveService";

export const ARCHIVED_STUDY_READONLY_MESSAGE =
  "This study is archived. You can view data only — changes are not allowed.";

export function isArchivedStudyReadOnly(studyRow) {
  return isStudyAlreadyArchived(studyRow);
}
